var _style, _circle, _path, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st321{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.4,
    cy: 262.3,
    r: 105.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.4,144c-65.3,0-118.2,52.9-118.2,118.2s52.9,118.2,118.2,118.2c65.3,0,118.2-52.9,118.2-118.2 C332.6,197,279.7,144,214.4,144C214.4,144,214.4,144,214.4,144z M214.4,370.5c-59.8,0-108.2-48.5-108.2-108.2S154.6,154,214.4,154 s108.2,48.5,108.2,108.2c0,0,0,0,0,0C322.5,322,274.1,370.4,214.4,370.5L214.4,370.5z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.4,
    cy: 262.3,
    r: 105.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.4,
    cy: 262.3,
    r: 105.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st321",
    cx: 195.7,
    cy: 221.2,
    r: 15.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st321",
    cx: 227.3,
    cy: 303.3,
    r: 15.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton01);
export default __webpack_public_path__ + "static/media/BUTTON-01.eed9435123d4c397823ebc04cb333ee8.svg";
export { ForwardRef as ReactComponent };